import moment from "moment-jalaali";

const addComma = (value: string) => {
  return Number(value).toLocaleString();
};
const removeComma = (value: string) => {
  const number = value.replace(/,/g, "");
  return number;
};

function groupBy(
  transactions: {
    [key: string]: any;
  }[],
  key: string
) {
  const groupedTransactions: {
    [key: string]: any;
  } = {};

  transactions.forEach((transaction) => {
    const keyValue = transaction[key];

    if (!groupedTransactions[keyValue]) {
      groupedTransactions[keyValue] = [];
    }

    groupedTransactions[keyValue].push(transaction);
  });

  return Object.values(groupedTransactions);
}
const persianMonth = (key: string) => {
  switch (key) {
    case "1":
      return "فروردین";
    case "2":
      return "اردیبهشت";
    case "3":
      return "خرداد";
    case "4":
      return "تیر";
    case "5":
      return "مرداد";
    case "6":
      return "شهریور";
    case "7":
      return "مهر";
    case "8":
      return "آبان";
    case "9":
      return "آذر";
    case "10":
      return "دی";
    case "11":
      return "بهمن";
    case "12":
      return "اسفند";
  }
};

export const persian_date = (date: string) => {
  const month = moment(date).format("jM");
  const day = moment(date).format("jD");
  const formattedDate = `${day} ${persianMonth(month)}`;
  return formattedDate;
};
export const UTILS = {
  groupBy: groupBy,
  addComma: addComma,
  removeComma: removeComma,
  persian_date: persian_date,
};
